import { useEffect, useState } from "react";
import { getRemainingTimeSinceClaim } from "../lib/time";

export default function useWheelTimer(availableRewards) {
  const [wheelReward, setWheelReward] = useState(null);
  const [remainingTime, setRemainingTime] = useState(null);
  const [expired, setExpired] = useState(null);

  useEffect(() => {
    if (!availableRewards.length) return;

    const reward = availableRewards.find((item) => item.type === "spin");
    if (!reward) return;

    setWheelReward(reward);

    // Update immediately
    const updateTimer = () => {
      const result = getRemainingTimeSinceClaim(reward.claimedAt);
      if (!result) return;
      setExpired(result.expired);
      setRemainingTime(
        `${result.hours}h ${result.minutes}m ${result.seconds}s`
      );
    };

    updateTimer(); // initial run
    const interval = setInterval(updateTimer, 1000); // tick every second

    return () => clearInterval(interval);
  }, [availableRewards]);

  return [wheelReward, remainingTime, expired];
}
